import React from 'react';
import { Box, Text } from 'tailwind-react-ui';
import CouponComponent from '../components/Coupon';
import EmailModalComponent from '../components/EmailModal';
import FloatingButtonComponent from '../components/FloatingButton';

const IWantItSection = () =>{

    const [showModal, setShowModal] = React.useState(false);

    return(
        <Box id="lo-quiero" className="i-want-it" flex alt="sixtynite-chelas-gratis">
            <Box className="landing-container" w={'full'}>
                <Text 
                is="h1" 
                className="oswald-bold title-white" 
                leading={'none'} 
                text={'white'}
                m={{b: 5}} >
                    2 CHELAS
                    <Text 
                    is="span" 
                    className="block oswald-bold title-yellow" 
                    leading={'none'} 
                    text={'yellow'}>
                        GRATIS
                    </Text>
                </Text>
                <Text 
                is="h3" 
                className="quicksand-regular tracking-widest max-w-sm"
                m={{b: 5}} 
                text={['white', 'lg']}>
                    <Text is="span" className="font-bold">PRESENTANDO ESTE CUPÓN </Text>
                    EN TU VISITA A UN MOTEL DE SIXTYNITE
                </Text>
                <Box className="w-full sm:w-full md:full lg:w-2/3 xl:w-3/4">
                    <CouponComponent 
                    id={'iWantCoupon'} 
                    type={'send'} 
                    onClick={() => setShowModal(true)}/>
                </Box>
                <Text is="p" className="quicksand-regular tracking-widest" text={'white'}  size="sm">
                    *Chelas sujeto a disponibilidad
                </Text>
            </Box>
            <FloatingButtonComponent onClick={() => setShowModal(true)}/>
            <EmailModalComponent showModal={showModal} setShowModal={(show) => setShowModal(show)}/>
        </Box>
    );
}

export default IWantItSection;